import React from 'react';
import { Checkbox } from 'baseui/checkbox';
import { LABEL_VALIDATIONS } from '../../image/labelling/constants';
import type { LabellingValidationsT } from '../types/types';
const CheckboxOverrides = {
  Root: {
    style: ({
      $theme
    }) => ({
      padding: $theme.sizing.scale300
    })
  },
  Label: {
    style: {
      fontWeight: 'normal'
    }
  }
};
type PropsT = {
  showRequiredLabel: boolean;
  updateValidation: (validations: LabellingValidationsT) => void;
  validations: LabellingValidationsT;
  additionOptionsVisibilityConfig: {
    invalidMedia: boolean;
    requiredLabel: boolean;
    noAnnotation: boolean;
  };
};
const AdditionalOptions = ({
  showRequiredLabel,
  validations,
  updateValidation,
  additionOptionsVisibilityConfig
}: PropsT) => {
  return <>
      {additionOptionsVisibilityConfig.invalidMedia ? <Checkbox checked={validations.invalidSource} onChange={e => {
      const updatedValidations = {
        ...validations
      };
      updatedValidations.invalidSource = e.target.checked;
      updateValidation(updatedValidations);
    }} overrides={CheckboxOverrides}>
          {"Image can't be labelled"}
        </Checkbox> : null}
      {showRequiredLabel && additionOptionsVisibilityConfig.requiredLabel && <Checkbox checked={validations.labelValidation.reasons.includes(LABEL_VALIDATIONS.REQUIRED_LABELS_NOT_AVAILABLE)} onChange={e => {
      const isValid = e.target.checked === false;
      const reason = LABEL_VALIDATIONS.REQUIRED_LABELS_NOT_AVAILABLE;
      const updatedValidations = {
        ...validations
      };
      const reasonIndex = updatedValidations.labelValidation.reasons.indexOf(reason);
      let reasons = updatedValidations.labelValidation.reasons;

      // remove the reason provided from existing reasons list
      if (reasonIndex >= 0) {
        reasons = [...updatedValidations.labelValidation.reasons.slice(0, reasonIndex), ...updatedValidations.labelValidation.reasons.slice(reasonIndex + 1)];
      }

      // if not isValid push the reason to existing reasons list
      if (isValid === false) {
        reasons = [...reasons, reason];
      }
      updatedValidations.labelValidation = {
        ...validations.labelValidation,
        isRequiredLabelAnnotated: reasons.length === 0,
        reasons
      };
      updateValidation(updatedValidations);
    }} overrides={{
      ...CheckboxOverrides,
      Input: {
        props: {
          'data-test-id': 'required-label-chk'
        }
      }
    }}>
          {'Required Labels not available'}
        </Checkbox>}
      {additionOptionsVisibilityConfig.noAnnotation && <Checkbox checked={validations.labelValidation.reasons.includes(LABEL_VALIDATIONS.NO_LABEL_AVAILABLE)} onChange={e => {
      const isChecked = e.target.checked === true;
      const updatedValidations = {
        ...validations
      };
      let reasons = updatedValidations.labelValidation.reasons;
      if (isChecked) {
        reasons = [...reasons, LABEL_VALIDATIONS.NO_LABEL_AVAILABLE];
      } else {
        const reasonIndex = updatedValidations.labelValidation.reasons.indexOf(LABEL_VALIDATIONS.NO_LABEL_AVAILABLE);
        if (reasonIndex >= 0) {
          reasons = [...updatedValidations.labelValidation.reasons.slice(0, reasonIndex), ...updatedValidations.labelValidation.reasons.slice(reasonIndex + 1)];
        }
      }
      updatedValidations.labelValidation = {
        ...validations.labelValidation,
        isRequiredLabelAnnotated: reasons.length === 0,
        reasons
      };
      updateValidation(updatedValidations);
    }} overrides={{
      ...CheckboxOverrides,
      Input: {
        props: {
          'data-testid': 'no-annotation-chk'
        }
      }
    }}>
          {'No Entity is present'}
        </Checkbox>}
    </>;
};
export default AdditionalOptions;